import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';

import { useTenantId } from '@/lib/tenant-context';

import {
  getMyProfile,
  updateMyProfile,
  type MyProfile,
  type UpdateMyProfileBody,
} from '../api/profile.api';

export function useMyProfile(enabled = true): UseQueryResult<MyProfile, Error> {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['me', tenantId, 'profile'] as const,
    queryFn: getMyProfile,
    enabled,
    staleTime: 5 * 60_000,
  });
}

export function useUpdateMyProfile(): UseMutationResult<MyProfile, Error, UpdateMyProfileBody> {
  const tenantId = useTenantId();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateMyProfileBody) => updateMyProfile(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['me', tenantId] }),
  });
}
